import { InitialState } from "../types";

export const initialState: InitialState = {
  postalAreas: {
    data: [],
    isLoading: false,
  },
  newPostalArea: {
    data: null,
    isLoading: false,
  },
  postalAreaDrawer: {
    visible: false,
    action: "NEW",
    record: null,
  },
};
